import i18nFactory from '@yandex-int/i18n';
import { ApolloQueryResult } from 'apollo-client';
import { isNull, pick } from 'lodash';

import { CryptaSegment } from '../../typings/cryptaSegments';
import {
    CryptaInterestTypeWeb,
    CryptaSegments,
    CryptaSegments_cryptaSegments_rowset,
    WebGoalType
} from '../../typings/graphql-grid';

import * as keyset from './cryptaSegments.i18n';

const i18n = i18nFactory(keyset);

export const mapCryptaSegmentsFromApiFormat = (
    cryptaData?: ApolloQueryResult<CryptaSegments>
): CryptaSegment[] => {
    if (!cryptaData) {
        return [];
    }

    // фейковый сегмент для аудио-жанров
    const audioFakeSegment = {
        id: cryptaData.data.reqId, // берем id запроса
        type: WebGoalType.audio_genres,
        name: i18n('audip-genres-title'),
        description: '',
        parentId: '0',
        interestType: CryptaInterestTypeWeb.all,
        canSelectAll: true,
        mutuallyExclusiveIds: []
    };

    return cryptaData.data.cryptaSegments.rowset
        .map(
            (row: CryptaSegments_cryptaSegments_rowset): CryptaSegment => ({
                ...pick(row, [
                    'type',
                    'name',
                    'description',
                    'canSelectAll',
                    'mutuallyExclusiveIds',
                    'interestType'
                ]),
                parentId: isNull(row.parentId)
                    ? null
                    : !Number(row.parentId) &&
                      row.type === WebGoalType.audio_genres
                    ? audioFakeSegment.id
                    : String(row.parentId),
                id: String(row.id)
            })
        )
        .concat(audioFakeSegment);
};
